import { browserSupportsWebAuthn, startAuthentication, startRegistration } from '@simplewebauthn/browser';
import type { PublicKeyCredentialCreationOptionsJSON, PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/browser';
import { AdminApiError, adminFetch } from './api';

export function supportsPasskeys() {
  return window.isSecureContext && browserSupportsWebAuthn();
}
export function passkeyError(error: unknown): string {
  if (error instanceof AdminApiError) return error.message;
  if ((error instanceof Error || error instanceof DOMException) && ['NotAllowedError', 'AbortError'].includes(error.name)) return '验证已取消或超时，可重新尝试。';
  if ((error instanceof Error || error instanceof DOMException) && error.name === 'InvalidStateError') return '此设备已有通行密钥，请使用已有密钥登录。';
  return '无法使用通行密钥，请重试或使用密码登录。';
}
export async function loginWithPasskey() {
  const options = await adminFetch<PublicKeyCredentialRequestOptionsJSON>('/auth/passkey/authentication/options', { method: 'POST', body: {} });
  const response = await startAuthentication({ optionsJSON: options });
  return adminFetch('/auth/passkey/authentication/verify', { method: 'POST', body: response });
}
export async function addPasskey(name: string, password: string, active: () => boolean) {
  const options = await adminFetch<PublicKeyCredentialCreationOptionsJSON>('/auth/passkey/registration/options', { method: 'POST', body: { name, password } });
  if (!active()) return;
  const response = await startRegistration({ optionsJSON: options });
  if (!active()) return;
  await adminFetch('/auth/passkey/registration/verify', { method: 'POST', body: response });
}
